module.exports = __webpack_public_path__ + "static/media/caja.c7454d4a.svg";